import { Link } from 'react-router-dom';
import { QUESTION_PLANS, formatPlanPrice } from '../data/plans';

export function PricingCards() {
  return (
    <div className="pricing-grid">
      {QUESTION_PLANS.map((plan) => (
        <article className={`price-card${plan.featured ? ' price-card--featured' : ''}`} key={plan.id}>
          {plan.featured ? <span className="price-card__badge">Most flexible</span> : null}
          <p className="eyebrow">{plan.name}</p>
          <div className="price-card__price">
            <strong>{formatPlanPrice(plan)}</strong>
            <span>one-time</span>
          </div>
          <p className="price-card__questions">{plan.questions} AI questions</p>
          <p>{plan.summary}</p>
          <ul className="check-list">
            <li>One complete AI response per question</li>
            <li>Conversation history in your account</li>
            <li>Private, focused workspace</li>
          </ul>
          <Link className={`button ${plan.featured ? 'button--warm' : 'button--outline'}`} to={`/checkout?plan=${plan.id}`}>
            Choose {plan.name}
          </Link>
        </article>
      ))}
    </div>
  );
}
